const baseEndpoint = process.env.REACT_APP_BASE_URL_API

export default class ApiService {
  getAllPlans(id:any) {
    const plans = fetch(`${baseEndpoint}/checkout/plan/${id}`, {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        return await response.json()
      } else return response.status
    }).catch((e) => console.log(e))
    return plans
  }
  
  getPurchaser(document: string) {
    const userData = fetch(
      `${baseEndpoint}/purchaser/${document.replace(/\D/g, '')}`
      , {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        const user = await response.json()
        return user
      } else {
        return response.ok
      }
    }).catch((e) => console.log('Comprador nao encontrado'))
    return userData
  }
  
  getAllPurchasers() {
    const plans = fetch(`${baseEndpoint}/purchaser`, {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        return await response.json()
      } else return response.status
    }).catch((e) => console.log(e))
    return plans
  }

  async getCommissionData(data: any) {
    
    if (data.affiliateId) {
      const couponProdPlan = fetch(`${baseEndpoint}/couponProdPlan/${data.couponId}/${data.planId}/${data.productId}/${data.affiliateId}`, {
        method: 'GET',
      }).then(async (response) => {
        if (response.ok) {
          return await response.json();
        } else return response.status
      }).catch((e) => console.log(e))      
      return couponProdPlan;
    } else {
      const couponProdPlan = fetch(`${baseEndpoint}/couponProdPlan/${data.couponId}/${data.planId}/${data.productId}/0`, {
        method: 'GET',
      }).then(async (response) => {
        if (response.ok) {
          return await response.json();
        } else return response.status
      }).catch((e) => console.log(e))      
      return couponProdPlan;
    }
    
  }
  
  async getAllProductPlans() {
    const domain = window.location.hostname;

    const plans = fetch(`${baseEndpoint}/checkout/productPlans/${domain}`, {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        return await response.json();
      } else return response.status
    }).catch((e) => console.log(e))      
    return plans
  }
  
  getProductDetails(id: number) {
    const productData = fetch(`${baseEndpoint}/checkout/product/${id}`, {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        const product = await response.json()
        return product
      } else {
        return response.ok
      }
    }).catch((e) => console.log(e))
    return productData
  }
  
  getClientDetails(id: string) {
    const ClientData = fetch(`${baseEndpoint}/checkout/client/${id}`, {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        const client = await response.json()
        return client
      } else {
        return response.ok
      }
    }).catch((e) => console.log(e))
    return ClientData
  }
  
  getAffiliateDetails(id: string) {
    const ClientData = fetch(`${baseEndpoint}/checkout/affiliate/${id}`, {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        const client = await response.json()
        return client
      } else {
        return response.ok
      }
    }).catch((e) => console.log(e))
    return ClientData
  }
  
  getCep = async (zipcode: string) => {
    const response = await fetch(`https://viacep.com.br/ws/${zipcode}/json`, {
      method: 'GET',
    }).then((res) => res.json()).catch((e) => console.log(e))
    return response
  }
  
  createAddress(data: object) {
    const response = fetch(`${baseEndpoint}/address/`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(async (response) => {
      if (!response.ok) {
        throw response
      }
      return await response.json()
    }).catch((e) => console.log(e))
    return response
  }

  sendDocumentsEmail(data: object) {
    const response = fetch(`${baseEndpoint}/emailSender/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    }).then(async (response) => {
      if (!response.ok) {
        throw response
      }
      return await response.json()
    }).catch((e) => console.log(e))
    return response
  }

  sendBoletoEmail(data: object) {
    const response = fetch(`${baseEndpoint}/emailSender/boleto`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    }).then(async (response) => {
      if (!response.ok) {
        throw response
      }
      return await response.json()
    }).catch((e) => console.log(e))
    return response
  }

  sendPixEmail(data: object) {
    const response = fetch(`${baseEndpoint}/emailSender/pix`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    }).then(async (response) => {
      if (!response.ok) {
        throw response
      }
      return await response.json()
    }).catch((e) => console.log(e))
    return response
  }

  sendCreditEmail(data: object) {
    const response = fetch(`${baseEndpoint}/emailSender/credit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    }).then(async (response) => {
      if (!response.ok) {
        throw response
      }
      return await response.json()
    }).catch((e) => console.log(e))
    return response
  }

  async completePaymentCredit(data: object) {
    try {
      const domain = window.location.hostname;
      const response =
        await fetch(`${baseEndpoint}/checkout/complete-payment-card`, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            ...data,
            domain,
          }),
        })
        .then(async (res) => {
          const result = await res.json()

          if (result.message) {
            throw new Error(JSON.stringify(result));
          }

          return result
        })
        .catch((err) => {
          const error = JSON.parse(err.message)
          const errorFormatted = JSON.parse(error.message)
          return {
            gateway: errorFormatted.gateway,
            paytimeError:
              errorFormatted.gateway === 'paytime' ? errorFormatted : null,
            pagarmeResponse:
              errorFormatted.gateway === 'pagarme' ? errorFormatted : null,
            status: "Falha",
          }
        });
      return response
    } catch (err: any) {
      console.log("🚀 ~ err:", err)
      throw new Error("Dados inválidos.");
    }
  }

  async completePaymentBankSlip(data: object) {
    try {
      const domain = window.location.hostname;
      const response =
        await fetch(`${baseEndpoint}/checkout/complete-payment-bank-slip`, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            ...data,
            domain,
          }),
        })
        .then(async (response) => {
          const data = await response.json();

          if (!response.ok) {
            throw new Error(JSON.stringify(data));
          }

          return { ...data, status: "Pendente" }
        }).catch((err) => {
          const error = JSON.parse(err.message)
          const errorFormatted = JSON.parse(error.message)
          return {
            status: "Falha",
            gateway: errorFormatted.gateway,
            paytimeError:
              errorFormatted.gateway === 'paytime' ? errorFormatted : null,
            pagarmeResponse:
              errorFormatted.gateway === 'pagarme' ? errorFormatted : null,
          }
        })
      return response
    } catch (e) {
      console.log(e)
      throw new Error("Dados inválidos.");
    }
  }

  async completePaymentPix(data: object) {
    try {
      const domain = window.location.hostname;
      const response =
        await fetch(`${baseEndpoint}/checkout/complete-payment-pix`, {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            ...data,
            domain,
          }),
        })
        .then(async (response) => {
          const data = await response.json();

          if (!response.ok) {
            throw new Error(JSON.stringify(data));
          }

          return { ...data, status: "Pendente" }
        }).catch((err) => {
          const error = JSON.parse(err.message)
          const errorFormatted = JSON.parse(error.message)
          return {
            status: "Falha",
            gateway: errorFormatted.gateway,
            paytimeError:
              errorFormatted.gateway === 'paytime' ? errorFormatted : null,
            pagarmeResponse:
              errorFormatted.gateway === 'pagarme' ? errorFormatted : null,
          }
        })
      return response
    } catch (e) {
      console.log(e)
      throw new Error("Dados inválidos.");
    }
  }

  createPurchaser(data: object) {
    const response = fetch(`${baseEndpoint}/purchaser/`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(async (response) => {
      if (!response.ok) {
        throw response
      }
      return await response.json()
    })
    return response
  }
  
  createSale(data: object) {
    const response = fetch(`${baseEndpoint}/sales/`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(async (response) => {
      if (!response.ok) {
        throw response
      }
      return await response.json()
    }).catch((e) => e.json())
    return response
  }

  getTermsAndPolicy() {
    const domain = window.location.hostname;
    const response = fetch(`${baseEndpoint}/checkout/generalInfo/${domain}`, {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        const data = await response.json()
        return data;
      } else {
        return response.ok
      }
    }).catch((e) => console.log(e))
    
    return response;
  }

  getTaxesLink() {
    const domain = window.location.hostname;
    const response = fetch(`${baseEndpoint}/checkout/taxes/${domain}`, {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        const data = await response.json()
        return data;
      } else {
        return response.ok
      }
    }).catch((e) => console.log(e))
    
    return response;
  }
  
  getCoupon(name: string) {
    const domain = window.location.hostname;

    const response = fetch(`${baseEndpoint}/coupon/name/${name}/${domain}`, {
      method: 'GET',
    }).then(async (response) => {
      if (response.ok) {
        const data = await response.json()
        return data;
      } else {
        return { message: 'Coupon not found' }
      }
    }).catch((e) => console.log(e))
    
    return response;
  }

  validateCoupon(
    name: string,
    productQuantity: number,
    totalPrice: number, 
    affiliateId: string,
  ) {
    const domain = window.location.hostname;

    const response = fetch(`${baseEndpoint}/coupon/validateCoupon/${name}/${domain}`, {
      method: 'POST',
      body: JSON.stringify({
        productQuantity,
        totalPrice,
        affiliateId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(async (response) => {
      if (response.ok) {
        const data = await response.json()
        return data;
      } else {
        return { message: 'Coupon not found' }
      }
    }).catch((e) => console.log(e))
    
    return response;
  }
  static async getProductBySlug(
    planSlug: string,
    productSlug: string,
    slug: string,
    clientDomain: string,
    coupon: string | null,
  ) {
      const slugEndpoint = slug.length> 0 ? 
      `${slug}/${planSlug}/${productSlug}/${clientDomain}` : 
      `${planSlug}/${productSlug}/${clientDomain}`;
      const response = await fetch(
        `${
          baseEndpoint
        }/productsPlans/${slugEndpoint}${
          coupon ? `?couponName=${coupon}` : ''
        }`, {
        method: 'GET',
      })
      const data = await response.json()
      return data
    }

  async verifyReCaptcha(reCaptchaToken: string) {
    try {
      const response =
        await fetch(`${baseEndpoint}/checkout/verify-recaptcha`, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token: reCaptchaToken }),
        })

      const result = await response.json();

      return result;
    } catch (err: any) {
      throw new Error(err);
    }
  }
  async completePaytimeAuth(data: object) {
    try {
      const domain = window.location.hostname;
      const response = await fetch(`${baseEndpoint}/checkout/complete-auth`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
        body: JSON.stringify({ ...data, domain }),
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(JSON.stringify(result));
      }
      return { ...result, status: "Pendente" };
    } catch (err: any) {
      console.error("completePaytimeAuth error:", err);
      throw new Error("Erro na autenticação 3DS");
    }
  }
  async getAffiliateTagsBySlug(slug: string) {
    try {
      const response = await fetch(`${baseEndpoint}/generalInformationsAffiliate/slug/${slug}`, {
        method: 'get',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
      });
      const result = await response.json();

      return result;
    } catch (err: any) {
      throw new Error(err);
    }
  }

  async createAbandonedSale(data: object) {
    try {
      const response = await fetch(`${baseEndpoint}/abandonedSales`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      return result;
    } catch (err: any) {
      throw new Error(err);
    }
  }
}
